import React, { Fragment } from "react";

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { welcome } from "../context/welcome";
import { global } from "../context/global";

export default function GuideDialog({ open, onClose }) {
    const { paragraphs, navigation } = welcome;
    const auth = useSelector((state) => state.auth);
    const navigate = useNavigate();

    if (!auth.account) {
        return null;
    }

    const handleLink = (link) => {
        onClose();
        navigate(link);
    };

    const NavItemInline = ({ navItem }) => (
        <li>
            <Typography
                display={"inline"}
                sx={{ cursor: "pointer", fontWeight: "bold", textDecoration: "underline" }}
                onClick={() => handleLink(navItem.link)}
            >
                {navItem.title}
            </Typography>
            <Typography display={"inline"}> - {navItem.description}</Typography>
        </li>
    );

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"md"}>
            <DialogTitle sx={{ color: "primary" }}>{welcome.title}</DialogTitle>
            <DialogContent>
                {paragraphs.map((paragraph, index) => (
                    <Fragment key={`text_${index}`}>
                        <Typography key={`p_${index}`}>{paragraph.introduction}</Typography>
                        <ul key={`li_p_${index}`}>
                            {paragraph.listItems.map((listItem, listItemIndex) => (
                                <li key={`li_${index}_${listItemIndex}`}>
                                    <Typography>{listItem}</Typography>
                                </li>
                            ))}
                        </ul>
                    </Fragment>
                ))}

                <Typography>{navigation.introduction}</Typography>
                <ul>
                    {auth.account.is_org_member &&
                        navigation.defaultItems.map((navItem, itemIndex) => (
                            <NavItemInline key={`default_nav_li_${itemIndex}`} navItem={navItem} />
                        ))}
                    <br />
                    {auth.account.is_staff &&
                        navigation.adminItems.map((navItem, itemIndex) => (
                            <NavItemInline key={`admin_nav_li_${itemIndex}`} navItem={navItem} />
                        ))}
                </ul>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{global.close}</Button>
            </DialogActions>
        </Dialog>
    );
}

